/**
 * External dependencies
 */
import React from 'react'
import classnames from 'classnames';

/**
 * Internal dependencies
 */
import './style.scss';
import Tooltip from 'Components/tooltip';
import Button from 'Components/button';
import Dashicon from 'Components/dashicon';

// This is intentionally a Component class, not a function component because it
// is common to apply a ref to the button element (only supported in class)
class IconButton extends React.Component {
	render() {
		const { icon, children, label, className, tooltip, position, focus, ...additionalProps } = this.props;
		const classes = classnames( 'components-icon-button', className );

		let element = (
			<Button { ...additionalProps } aria-label={ label } className={ classes } focus={ focus }>
				<Dashicon icon={ icon } />
				{ children }
			</Button>
		);

		if ( label && ! children && false !== tooltip ) {
			element = <Tooltip text={ tooltip || label } position={position} >{ element }</Tooltip>;
		}

		return element;
	}
}

export default IconButton;



// WEBPACK FOOTER //
// ./dev/stylist_parent/components/icon-button/index.js